import { ApolloClient, InMemoryCache, createHttpLink, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { fetchWithHeaders } from '../api/fetchWithHeaders';
import { useAuthStore } from '../stores/authStore';

const url = import.meta.env.VITE_API_BASE_URL;

const httpLink = createHttpLink({
  uri: url + 'api/v1/graphql',
  fetch: (uri: any, options: any) => fetchWithHeaders(uri, options)
});

const wsLink = new GraphQLWsLink(createClient({
  url: url + 'api/v1/graphql',
  // we can't use fetchWithHeaders here because it doesn't support ws
  connectionParams: () => {
      const token = useAuthStore.getState().token;
      return {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      };
    },
}));

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink,
);

export const apolloClient = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  },
});
